import React from 'react';

// The document-type <option>s for any filing <select>, from the folder table (utils/docVocab): one <optgroup> per
// folder — property folders, then client folders, in the table's order — each listing its active types.
// value = the type KEY, label = its display NAME. Used by every type pick list, so they cannot disagree again.
//
// `levels` — which filing levels to offer. Default property + client: only Document Intake can file against a
// consultant (it has the Consultant picker), so it alone passes DOC_LEVELS. Consultant folder groups are prefixed
// "Consultant ·" because a consultant folder may share its name with a client one (both "Contracts").
//
// `current` — a type already chosen that has since been retired still appears (marked), so an existing selection
// never silently blanks.
export default function DocTypeOptions({ vocab, current = '', levels = ['property', 'client'] }) {
  if (!vocab) return <option value="" disabled>Loading types…</option>;
  const groups = levels.flatMap(level => vocab.foldersByLevel(level).map(f => ({ folder: f, types: vocab.typesIn(f.key) })));
  const retired = current && vocab.type(current) && !vocab.type(current).active ? vocab.type(current) : null;
  return (
    <>
      {groups.filter(g => g.types.length).map(({ folder, types }) => (
        <optgroup key={folder.key} label={`▸ ${folder.level === 'consultant' ? 'Consultant · ' : ''}${folder.name}`}>
          {types.map(t => <option key={t.key} value={t.key}>{t.name}</option>)}
        </optgroup>
      ))}
      {retired && <option value={retired.key}>{retired.name} (retired)</option>}
    </>
  );
}
